module.exports = __webpack_public_path__ + "img/complaint.56138ef3.svg";